import {connect} from 'react-redux';
import {ExperimentalSetupPoster as Component} from './ExperimentalSetupPoster';
import {
  showModal
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    levelSelected: state.notebook.levelSelected
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    }
  };
}

export const ExperimentalSetupPoster = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
